(function(window, angular){'use strict';

// @todo JIRA make this a behaviour of tooltips inside collapsing boxes
$('.no-collapse').click(function (event) {
    event.stopPropagation();
});
})(window, window.angular);